import React from 'react';
import { PlusOutlined } from '@ant-design/icons';

const uploadButton = (
  <div>
    <PlusOutlined />
    <div className="ant-upload-text">上传</div>
  </div>
);

const getUploadProps = isVideo => {
  return {
    accept: isVideo ? '.rmvb, .mp4' : '.jpg, .jpeg, .png',
    action: 'https://upload.qiniup.com',
    listType: 'picture-card',
    multiple: true,
    progress: {
      strokeColor: {
        '0%': '#108ee9',
        '100%': '#87d068',
      },
      strokeWidth: 3,
      format: percent => `${parseFloat(percent.toFixed(2))}%`,
    },
  };
};

const schema = [
  {
    type: 'input',
    name: 'file_name',
    placeholder: '请输入文件名',
  },
  {
    type: 'rangepicker',
    name: 'data',
    placeholder: '请输入文件名',
  },
];

const mapName = [
  {
    name: 'data',
    keys: ['start_upload_at', 'end_upload_at'],
  },
];

const columns = {
  url: {
    type: 'imgView',
  },
  operation: {
    width: 100,
    btnList: [
      {
        text: '选择',
        clickEvent: 'selectFile',
      },
    ],
  },
};

export { uploadButton, getUploadProps, schema, mapName, columns };
